import { createSlice } from "@reduxjs/toolkit";
import { persistStore } from "redux-persist"; // Import persistStore

// import { singIn } from "../../reduxApi/SingIn&SingUp/SinginApi";
// import { storeDataAfterGoogelSingin } from "../../reduxApi/SingIn&SingUp/SingInWithGoogelApi";
import { customerLogin } from "../../api/customer/customerAuth";

const initialState = {
  status: "idle",
  SingIn: null,
  error: null,
  authToken: null,
};

const SingInSlice = createSlice({
  name: "SingIn",
  initialState,
  reducers: {
    logout: () => initialState,
    setCatalystUser: (state, action) => {
      state.SingIn = action.payload;
      state.status = "fulfilled";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(customerLogin.pending, (state) => {
        state.status = "pending";
      })
      .addCase(customerLogin.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.SingIn = action.payload;
        console.log("Sing In Response: without Google", state.SingIn);
      })
      .addCase(customerLogin.rejected, (state, action) => {
        state.status = "rejected";
        state.error = action.error.message;
      })
      // .addCase(storeDataAfterGoogelSingin.fulfilled, (state, action) => {
      //   state.status = "fulfilled";
      //   state.SingIn = action.payload;
      //   console.log("Sing In Response: Google", state.SingIn);
      // });
  },
});

export const { logout,setCatalystUser } = SingInSlice.actions;
export default SingInSlice.reducer;
